import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";

import useUpSellProducts from "@hooks/useUpSellProducts";
import { useLocalizedProductsWithDiscount } from "@hooks/useLocalizedCartInfo";

import UpSells from "./UpSells";

function UpSellsRecommendation() {
  const { data: recommendedProducts, isLoading } = useUpSellProducts();
  const products = useLocalizedProductsWithDiscount(recommendedProducts);

  return (
    <UpSells
      title="You May Also Like"
      products={products}
      isLoading={isLoading}
      slidesPerView={1.3}
    />
  );
}

export default withALErrorBoundary({
  name: "UpSellsRecommendation",
  priority: "P3",
})(UpSellsRecommendation);
